var React = require('react');

function PlusCircleComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm-1-12V6h2v5h5v2h-5v5h-2v-5H6v-2h5z"}));
}

PlusCircleComponent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = PlusCircleComponent;

PlusCircleComponent.default = PlusCircleComponent;
